export function translate(literal, vars) {
  // Callers sometimes pass API values (e.g. numeric contract numbers); never crash on them.
  if (literal === null || literal === undefined) return '';
  return String(literal).replace(/{([a-zA-Z_]+)}/g, (_, key) => vars?.[key] ?? key);
}
